import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTitle } from '../../Application';
import ScopesView from '../../ui/views/Scopes/Scopes';
import {apiClient} from "../../services/api";
import {fetchDevices} from "../../connectors/Devices/actions";
import UpdateScreen from "../../ui/views/Dialog/UpdateScreen";
import NoDevice from "../../ui/views/Dialog/NoDevice";
import {whiteLabelData} from "../../ui/theme"
import log from 'loglevel'
import { t } from 'i18next';

var pageTitle = ""
const title = whiteLabelData.name

const mapStateToProps = state => ({
    title: state.application.title,
    map: state.devices.map,
    currentDevice: (state.devices.map[state.devices.active] || { scopes: {} }),
    // settings: (state.devices.map[state.devices.active].state.varlist) || {deviceVarList: {}},
    scopes: (state.devices.map[state.devices.active] || { scopes: {} }).deviceStates,
    currentDeviceId: (state.devices.map[state.devices.active] || { scopes: {} }).deviceid,
    currentDeviceName: (state.devices.map[state.devices.active] || { scopes: {} }).label
});

const mapDispatchToProps = dispatch => ({
    fetchDevices: (callback) => dispatch(fetchDevices(callback)),
});

/**
 * Scopes
 */
class Scopes extends Component {
  static propTypes = {

  }

  static defaultProps = {
    scopes: {},
  }

    constructor(props) {
      super(props)
      this.state.deviceVarList = this.props.settings
      this.currentZone = 1;

    }

    state = {

      deviceVarList: []
    }

    componentDidMount() {
        setTimeout(() =>{
            this.props.fetchDevices((data) => {
               // if(data.length == 0) {this.props.history.push("/onboarding");}

            });
        }, 2000)
    }

    shouldComponentUpdate() {
      return true;
    }

    componentWillMount(){
      // this.secondLoad()
      pageTitle = " - " + t('PageTitles.areas')
    }

    secondLoad = () => {
      var data = { deviceid: this.props.currentDeviceId }
      log.debug("SECONDLOAD")
      apiClient.post('control/settings/store', data)
        .then(res => {
          if (res.status === 200) {
            log.debug("STATE UPDATE CMD OK")
            this.props.fetchDevices()
          }
        })
        .then(()=> {
          setTimeout(() =>{
            this.props.fetchDevices()
              log.debug("2 Seconds LATER")

        }, 2000)
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {

    }



    onVentilationLevelChanged = (val) => {
        log.debug("onVentilationLevelChanged", val)
        var data = {deviceid: this.props.currentDeviceId, zone: this.currentZone, value: val}
        apiClient.post('control/fanlevel', data)
            .then((response) => {
                if (response.ok === true) {
                    return response.json();
                }
            })
            .catch((err) => {
                log.error("ERROR ON FAN LVL CHANGED", err);
            })
    };

    onModeChanged = (mode) => {
      var data = {deviceid: this.props.currentDeviceId,zone: this.currentZone, mode: mode}

      apiClient.post('control/mode', data)
          .then((response) => {
              if (response.ok === true) {
                  return response.json();
              }
          })
          .catch((err) => {
              log.error("ERROR ON MODE CHANGED", err);
          })
    };

    onZoneSelected = (zone) => {
      log.debug("zone selected", zone);
      this.currentZone = zone.index;
    };

  render() {
    log.debug("SCOPES.jsx PROPS",this.props)
    if (this.props.currentDevice != null && this.props.currentDevice.updateNeeded) {
      return <UpdateScreen currentDevice={this.props.currentDevice}></UpdateScreen>;
    }

    if (this.props.currentDevice.state === undefined) {
      return <NoDevice></NoDevice>;
    }

    return (
      <ScopesView
        title={this.props.currentDeviceName + pageTitle}
        currentDeviceId={this.props.currentDeviceId}
        scopes={this.props.scopes}
        onZoneSelected={this.onZoneSelected}
        onModeChanged={this.onModeChanged}
        onVentilationLevelChanged={this.onVentilationLevelChanged}
        onMyload = {this.secondLoad}
        settings = {this.props.currentDevice.state.varlist}
      />
    );
  }
}

export default withTitle(withRouter(connect(mapStateToProps, mapDispatchToProps)(Scopes)), title);
